import { graphql } from 'react-relay';

import { useDomainName_company } from './__generated__/useDomainName_company.graphql';

// eslint-disable-next-line
graphql`
  fragment useDomainName_company on Company {
    id
    name
  }
`;

export const useDomainName = (company: useDomainName_company) => {
  return !!company;
};
